<script>
import { mapActions } from 'vuex'
import capitalize from 'lodash/capitalize'

export default {
  name: 'DeleteProductModal',
  props: {
    providerId: {
      type: String,
      default: '',
    },
    providerProductId: {
      type: String,
      default: '',
    },

    supplierId: {
      type: String,
      default: '',
    },
    sku: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: '',
      validator: v => !v || /supplier|provider/.test(v),
    },
  },
  data() {
    return {
      progress: false,
    }
  },
  methods: {
    capitalize,
    ...mapActions('providerProduct', ['deleteProviderProduct']),
    ...mapActions('supplierProduct', ['deleteSupplierProduct']),
    async onSubmit() {
      const { providerId, providerProductId, supplierId, sku, type } = this
      let request

      this.progress = true

      if (type === 'provider') {
        request = this.deleteProviderProduct({ providerId, providerProductId })
      } else {
        request = this.deleteSupplierProduct({ supplierId, sku })
      }

      const response = await request

      this.progress = false

      this.$notifier({
        response,
        successMsg: 'Successfully deleted',
      }).then(success => {
        this.$modal.self.hide()
        this.$router.push({ name: `${type}-products` })

        this.$emit('update:visible', false)
      })
    },
  },
}
</script>

<template>
  <base-modal :state-modal="true">
    <state-modal-dialog :title="`Delete ${capitalize(type)} Product`">
      <el-icon
        slot="icon"
        name="warning"
      />
      <el-icon
        slot="subicon"
        name="delete"
      />
      <div slot="message">
        <template v-if="type === 'provider'">
          Are you sure you wish to delete this Provider Product?
        </template>
        <template v-if="type === 'supplier'">
          Are you sure you would like to delete this Supplier Product?
        </template>
      </div>
      <div
        v-if="type === 'supplier'"
        slot="note"
      >
        This will result in all associated Provider Products through any active
        Contracts also being Deleted
      </div>
      <div class="modal__footer">
        <el-button
          type="danger"
          :loading="progress"
          class="el-button--wide"
          @click="onSubmit"
        >
          {{ `Delete ${capitalize(type)} Product` }}
        </el-button>
      </div>
    </state-modal-dialog>
  </base-modal>
</template>
